import { render, staticRenderFns } from "./SendGridContactExportBtn.vue?vue&type=template&id=047cb7cd&scoped=true&"
import script from "./SendGridContactExportBtn.vue?vue&type=script&lang=js&"
export * from "./SendGridContactExportBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047cb7cd",
  null
  
)

export default component.exports